export default "__VITE_ASSET__a477039c__"